import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_instructor/student/notes')({
  component: () => <Outlet />,
});
